import { createReducer, on } from '@ngrx/store';
import { CustomerDPApiError } from './customer-dp.errors';
import {
  CollectDnaButtonClicked,
  LoadBlendStateSucceeded,
  LoadBlendStateErrored,
  RemoveCustomerDPError,
} from './customer-dp.actions';
import { BlendState } from 'src/app/shared/types/blend-state.type';

export interface CustomerDPState {
  error?: CustomerDPApiError;
  requestedBlendState: BlendState;
}

export const initialCustomerDPState: CustomerDPState = {
  error: null,
  requestedBlendState: {},
};

export const customerDPReducer = createReducer(
  initialCustomerDPState,
  on(LoadBlendStateErrored, (state, { error }) => ({
    ...state,
    error,
  })),
  on(CollectDnaButtonClicked, (state) => ({
    ...state,
    error: null,
  })),
  on(LoadBlendStateSucceeded, (state, { blendState }) => ({
    ...state,
    requestedBlendState: blendState,
  })),
  on(RemoveCustomerDPError, (state) => ({
    ...state,
    error: null,
  })),
);
